import axios from 'axios'
import { ACATS_MARGIN_DETAILS_API, WITH_CREDENTIALS_CONFIG } from './constants'

export const getMarginDetails = (
  accountNumber: string,
  acatsControlNumber: string
) => {
  return axios.get(
    ACATS_MARGIN_DETAILS_API(accountNumber, acatsControlNumber),
    WITH_CREDENTIALS_CONFIG
  )
}
